import useFetcher from 'hooks/useFetcher/useFetcher';
import { ServiceTypes } from 'hooks/useFetcher/interfaces';
import { stringifyUrl, getRequest } from 'utils';
import { Properties } from 'types';

export const useReasonsAPI = (): Properties => {
  const fetcher = useFetcher(ServiceTypes.CRM);

  return {
    getReasons: ({ queryKey: [, query] }) => {
      return fetcher(stringifyUrl(`/refusal-reasons`, query), getRequest);
    },
    getReasonById: ({ queryKey: [, { id }] }) => fetcher(`/refusal-reasons/${id}`, getRequest),
    createReason: (data) => {
      return fetcher('/refusal-reasons', {
        data,
        request: {
          method: 'POST',
        },
      });
    },
    updateReason: ({ id, ...data }) => {
      return fetcher(`/refusal-reasons/${id}`, {
        data,
        request: {
          method: 'PUT',
        },
      });
    },
    deleteReason: (id: number) => {
      return fetcher(`/refusal-reasons/${id}`, {
        request: {
          method: 'DELETE',
        },
      });
    },
  };
};
